var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);} /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useMemo, useState } from 'react';
import {
  flexRender,
  getSortedRowModel,
  getCoreRowModel,
  useReactTable } from

'@tanstack/react-table';
import { CheckBoxHeader, CheckBoxCell, getIcon } from "./TableElements";

const applyForSelection = (
withSelection,
withOutSelection,
enableSelection = false) =>
enableSelection ? withSelection : withOutSelection;

// eslint-disable-next-line comma-spacing
const Table = ({
  columns,
  data,
  title,
  footer,
  initialState,
  enableSelection,
  onSelection
}) => {
  const [sorting, setSorting] = useState((initialState === null || initialState === void 0 ? void 0 : initialState.sorting) || []);
  const [rowSelection, setRowSelection] = useState({});

  const memoizedColumns = useMemo(
    () => [
    ...applyForSelection(
      [_objectSpread(_objectSpread({},

      {
        id: 'checkbox-select',
        header: CheckBoxHeader,
        cell: CheckBoxCell
      }), {}, {
        className: 'w-0' })],


      [],
      enableSelection
    ),
    ...columns],

    [columns, enableSelection]
  );

  const preparedData = useMemo(() => {
    setRowSelection({});
    return data;
  }, [data]);

  const table = useReactTable({
    columns: memoizedColumns,
    data: preparedData,
    initialState,
    state: _objectSpread({
      sorting },
    applyForSelection({ rowSelection }, {}, enableSelection)),

    enableRowSelection: enableSelection,
    onRowSelectionChange: applyForSelection(setRowSelection, () => undefined, enableSelection),
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel()
  });

  useEffect(() => {
    const selectedRows = table.getSelectedRowModel().flatRows;

    if (onSelection) {
      onSelection(selectedRows);
    }
  }, [onSelection, rowSelection, table]);

  return /*#__PURE__*/(
    _jsx("div", { className: "relative overflow-x-auto border rounded-md shadow-sm border-gray-50" }, void 0, /*#__PURE__*/
    _jsx("table", { className: "w-full text-sm text-left" }, void 0,
    title && /*#__PURE__*/
    _jsx("caption", { className: "p-4 text-base font-semibold text-left text-gray-900 bg-white" }, void 0,
    title
    ), /*#__PURE__*/


    _jsx("thead", { className: "text-xs text-gray-700 uppercase bg-gray-50" }, void 0,
    table.getHeaderGroups().map((headerGroup) => /*#__PURE__*/
    _jsx("tr", {}, headerGroup.id,
    headerGroup.headers.map((header) => {var _header$column$column;
      const isSortable = header.column.getCanSort();
      const isSelect = header.column.id === 'checkbox-select';
      const headerClassName = `${isSelect ? 'px-2' : 'px-6'} py-3 ${
      ((_header$column$column = header.column.columnDef.meta) === null || _header$column$column === void 0 ? void 0 : _header$column$column.className) || ''
      }`;

      return /*#__PURE__*/(
        _jsx("th", { scope: "col", className: headerClassName }, header.id, /*#__PURE__*/
        _jsx("div", {
          className: `inline-flex ${isSortable ? 'cursor-pointer select-none' : ''}`,
          onClick: header.column.getToggleSortingHandler() }, void 0,

        flexRender(header.column.columnDef.header, header.getContext()),
        isSortable && getIcon(header.column.getIsSorted())
        )
        ));

    })
    )
    )
    ), /*#__PURE__*/

    _jsx("tbody", {}, void 0,
    table.getRowModel().rows.map((row) => /*#__PURE__*/
    _jsx("tr", { className: "bg-white border-b" }, row.id,
    row.getVisibleCells().map((cell) => {
      const isSelect = cell.column.id === 'checkbox-select';

      return /*#__PURE__*/(
        _jsx("td", { className: `${isSelect ? 'px-2' : 'px-6'} py-3` }, cell.id,
        flexRender(cell.column.columnDef.cell, cell.getContext())
        ));

    })
    )
    )
    )
    ),
    footer && /*#__PURE__*/_jsx("div", { className: "p-4" }, void 0, footer)
    ));

};
export { Table };